import { render, staticRenderFns } from "./oddsauto.vue?vue&type=template&id=7ec8983a&"
import script from "./oddsauto.vue?vue&type=script&lang=js&"
export * from "./oddsauto.vue?vue&type=script&lang=js&"
import style0 from "./oddsauto.vue?vue&type=style&index=0&id=7ec8983a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports